import { useMutation, gql } from "@apollo/client"
import { ADMINABLE_USERS_FIELDS } from "./useQueryAdminableUsers"

const UPDATE_USERS_MUTATION = gql`
  ${ADMINABLE_USERS_FIELDS}
  mutation UpdateUsers(
    $ids: [ID!]!
    $groups: [ID!]
    $locations: [ID!]
    $roles: [ID!]
    $addGroups: [ID!]
    $addLocations: [ID!]
    $addRoles: [ID!]
    $addTrainingCourses: [ID!]
    $addAccreditations: [ID!]
    $removeGroups: [ID!]
    $removeLocations: [ID!]
    $removeRoles: [ID!]
    $removeAccreditations: [ID!]
    $status: AdminableUserStatus
  ) {
    updateUsers(
      ids: $ids
      groups: $groups
      locations: $locations
      roles: $roles
      addGroups: $addGroups
      addLocations: $addLocations
      addRoles: $addRoles
      addTrainingCourses: $addTrainingCourses
      addAccreditations: $addAccreditations
      removeGroups: $removeGroups
      removeLocations: $removeLocations
      removeRoles: $removeRoles
      removeAccreditations: $removeAccreditations
      status: $status
    ) {
      ...AdminableUsersFields
    }
  }
`

const useMutationUpdateUsers = () => useMutation(UPDATE_USERS_MUTATION)

export { useMutationUpdateUsers }
